import buttonLoading from 'assets/images/button_loading.gif';

import type { JSX } from 'react';

/**
 * ボタン用のインディケーターを表示するコンポーネント
 */
export default function IndicatorButton(props: { visible: boolean }): JSX.Element {
  return (
    <>
      {props.visible && (
        <img className="loading me-2" src={buttonLoading} style={{ width: '16px' }} />
      )}
    </>
  );
}
